import { Injectable } from '@angular/core';

@Injectable()
export class StaticTooltipsService {
  private bdMatrixTooltipDismissed = false;
  private bdCompanySelectionTooltipDismissed = false;
  private irInfoTooltipDismissed = false;
  private frDetailTooltipDismissed = false;

  get businessDescCompanySelectionTooltipDismissed(): boolean {
    return this.bdCompanySelectionTooltipDismissed;
  }
  set businessDescCompanySelectionTooltipDismissed(value: boolean) {
    this.bdCompanySelectionTooltipDismissed = value;
  }

  get businessDescMatrixTooltipDismissed(): boolean {
    return this.bdMatrixTooltipDismissed;
  }
  set businessDescMatrixTooltipDismissed(value: boolean) {
    this.bdMatrixTooltipDismissed = value;
  }

  get internetReviewInfoTooltipDismissed(): boolean {
    return this.irInfoTooltipDismissed;
  }
  set internetReviewInfoTooltipDismissed(value: boolean) {
    this.irInfoTooltipDismissed = value;
  }

  get fnReviewDetailTooltipDismissed(): boolean {
    return this.frDetailTooltipDismissed;
  }
  set fnReviewDetailTooltipDismissed(value: boolean) {
    this.frDetailTooltipDismissed = value;
  }
}
